import React, { FC } from 'react';
import styles from './SelectedImagePreview.module.css';

export interface SelectedImagePreviewProps {
  imageUrl: string;
  imageTitle: string;
  disabled: boolean;
  onClearSelection: () => void;
}

export const SelectedImagePreview: FC<SelectedImagePreviewProps> = ({
  imageUrl,
  imageTitle,
  disabled,
  onClearSelection,
}) => (
  <div className={styles.selectedImageContainer}>
    <div className={styles.selectedImageInfo}>
      <img src={imageUrl} alt={imageTitle} className={styles.selectedImage} />
      <div className={styles.selectedImageDetails}>
        <span className={styles.selectedLabel}>Selected:</span>
        <span className={styles.selectedTitle}>{imageTitle}</span>
      </div>
    </div>
    <button
      className={styles.closeButton}
      onClick={onClearSelection}
      disabled={disabled}
      title="Remove selected image"
      aria-label="Remove selected image"
      data-testid="remove-selection-button"
    >
      ×
    </button>
  </div>
);
